import { render, staticRenderFns } from "./ClassVerticalChooseWidget.vue?vue&type=template&id=71e6b985&scoped=true&"
import script from "./ClassVerticalChooseWidget.vue?vue&type=script&lang=js&"
export * from "./ClassVerticalChooseWidget.vue?vue&type=script&lang=js&"
import style0 from "./ClassVerticalChooseWidget.vue?vue&type=style&index=0&id=71e6b985&lang=scss&scoped=true&"
import style1 from "./ClassVerticalChooseWidget.vue?vue&type=style&index=1&id=71e6b985&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e6b985",
  null
  
)

export default component.exports